import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _templateObject, _minHeight;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from "react";
import { createGlobalStyle, MarkdownRenderer, mediaCSS, ProProviders, ProStore, RedoclyReferenceDocs, Section, ZERO_BREAKPOINT } from "@redocly/reference-docs";
import { navigate } from "gatsby";
import { configure } from "mobx";
import { observer } from "mobx-react";
import ApiReferenceInfo from "../components/UserComponents/ApiReferenceInfo";
import { appTheme } from "../appTheme";
import { PageHeader } from "../components/PageHeader/PageHeader";
import { PAGE_TYPES, REDOC_OVERVIEW_ITEM_ID } from "../../constants";
import { usePageData, usePathPrefix } from "../ui/utils";
import { getNavbarElement } from "../utils";
import "../fragments";
import { getUserId } from "../ui/auth/utils";
import { useIdpLoginPath } from "../components/RedirectToLogin";
import { FakeControlsWrap } from "../components/styled";
import { getHooks } from "./get-hooks";
import { joinWithSeparator } from "../helpers";
var DEFAULT_OAUTH2_REDIRECT_PAGE = "/_auth/oauth2-redirect.html";
configure({
  isolateGlobalState: !0,
  useProxies: "ifavailable"
});

var oldRender = MarkdownRenderer.prototype.renderMd,
    _getHooks = getHooks(),
    events = _getHooks.events,
    requestInterceptor = _getHooks.requestInterceptor,
    hooks = _objectWithoutPropertiesLoose(_getHooks, ["events", "requestInterceptor"]);

function RedocPage(a) {
  var _a$data$contentItem = a.data.contentItem,
      b = _a$data$contentItem.type,
      c = _a$data$contentItem.data,
      _usePageData = usePageData(),
      d = _usePageData.referenceDocsStoreJson,
      e = a.data.contentItem.data.redocItemId,
      _React$useState = React.useState(),
      f = _React$useState[0],
      g = _React$useState[1],
      h = React.useMemo(function () {
    var _f$options$hooks, _f$options$hooks2, _f$options$hooks2$onI;

    if (!d) return null;
    d.options = _objectSpread(_objectSpread({}, d.options || {}), c.settings || {}), d.options.disableSearch = !0, d.options.ctrlFHijack = !1, d.options.showNextButton = !1, d.options.theme = appTheme || {}, d.options.hooks = hooks, d.options.events = events, d.options.requestInterceptor = requestInterceptor;
    var b = usePathPrefix();

    if (d.options.routingBasePath = a.pageContext.pageBaseUrl || void 0, d.options.oAuth2RedirectURI = "undefined" == typeof window ? null : "" + window.location.origin + b + DEFAULT_OAUTH2_REDIRECT_PAGE, d.options.disableSidebar = !0, d.options.pagination = d.options.pagination || "item", d.options.disablePaginationLoadingAnimation = void 0 === d.options.disablePaginationLoadingAnimation ? "section" !== d.options.pagination : d.options.disablePaginationLoadingAnimation, d.options.skipBundleAndConvert = !0, d.options.unauthorizedTryIt && !getUserId()) {
      var _c = b + a.data.contentItem.link;

      var _e = d.options.unauthorizedTryIt.link;

      var _f = _e || useIdpLoginPath();

      d.options.unstable_tryItButtonOverride = {
        label: d.options.unauthorizedTryIt.label,
        onClick: function onClick() {
          navigate(_f + "?redirect_to=" + encodeURIComponent(_c));
        }
      };
    }

    d.options.linkForId = function (a) {
      if (!a) return "";

      if (a.startsWith("section/Authentication/")) {
        if (!c.redocHasSecurityDefinitions) return "";
        if ("none" !== d.options.pagination) return c.redocInfoPageLink ? b + c.redocInfoPageLink + "#" + a : "";
      }

      return "#" + a;
    }, d.options.generateDeepLink = function (a, b) {
      switch (d.options.pagination) {
        case "item":
          return "#!" + a;

        case "section":
        case "none":
          return "#" + joinWithSeparator(b.split("#")[1] || "", a, d.options.deepLinkPrefix || "!");
      }

      return null;
    }, d.options.onDeepLinkClick = function (a) {
      navigate(a), "item" === d.options.pagination && f.menu.history.replaceForField(e + a.substr(1));
    }, d.options.scrollYOffset = function () {
      var a = getNavbarElement();
      return a && a.getBoundingClientRect().bottom || 74;
    };
    var f = ProStore.fromJS(d),
        g = a.pageContext.pageBaseUrl || "";
    MarkdownRenderer.prototype.renderMd = function (a, b) {
      var c = oldRender.apply(this, [a, b]);
      return c.replace(/<a href="#(section|operation|tag)\/([^\/"]*)(?:\/([^"]*))?"/g, function (a, b, c, d) {
        return "<a href=\"" + g + "/" + b + "/" + c + (d ? "#" + d : "") + "\"";
      });
    }, Object.defineProperty(f.menu.history, "replace", {
      get: function get() {
        return function (a) {
          a && navigate(f.menu.history.linkForId(a));
        };
      },
      configurable: !0
    });
    var h = f.menu.flatItems.find(function (a) {
      return a.id === e;
    });
    return f.menu.activate(h, !1, !1, !1), hooks.onPagination && hooks.onPagination({
      operation: "operation" === (h === null || h === void 0 ? void 0 : h.type) ? h : void 0,
      item: h,
      store: f
    }), (_f$options$hooks = f.options.hooks) !== null && _f$options$hooks !== void 0 && _f$options$hooks.onInit && (_f$options$hooks2 = f.options.hooks) !== null && _f$options$hooks2 !== void 0 && (_f$options$hooks2$onI = _f$options$hooks2.onInit) !== null && _f$options$hooks2$onI !== void 0 && _f$options$hooks2$onI.call(_f$options$hooks2, {
      store: f
    }), f;
  }, [d]);

  if (React.useEffect(function () {
    switch (h === null || h === void 0 ? void 0 : h.options.pagination) {
      case "item":
        g(window.location.hash.substring(1));
        break;

      case "section":
      case "none":
        g(window.location.hash.split(h.options.deepLinkPrefix)[1]);
    }
  }, [h]), React.useLayoutEffect(function () {
    if (!h) return;
    var a = window.location.hash.substring(1).split(h.options.deepLinkPrefix)[0],
        b = h.menu.flatItems.find(function (b) {
      return b.id === a;
    }) || h.menu.activeItem,
        c = f ? joinWithSeparator((b === null || b === void 0 ? void 0 : b.id) || "", f, h.options.deepLinkPrefix) : void 0;
    c && h.menu.history.replaceForField(c || ""), h.menu.activateAndScroll(b, !1, void 0, c);
  }, [f, h]), React.useEffect(function () {
    if (h) {
      var _a = h.menu.flatItems.find(function (a) {
        return a.id === e;
      });

      h.menu.activate(_a, !1, !1, !1);
    }
  }, [e]), !h) return null;
  var i;
  return i = b === PAGE_TYPES.referenceDocsOverview && "none" !== d.options.pagination ? /*#__PURE__*/React.createElement(ApiReferenceInfo, {
    store: h,
    data: c
  }) : /*#__PURE__*/React.createElement(RedoclyReferenceDocs, {
    store: h,
    _forceRenderInfo: e === REDOC_OVERVIEW_ITEM_ID && c.redocHasInfoPage
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHeader, {
    seo: a.pageContext.seo
  }), /*#__PURE__*/React.createElement(ProProviders, {
    store: h
  }, i), /*#__PURE__*/React.createElement(CssFixes, {
    withLayoutButtons: h.options.showRightPanelToggle || h.options.showChangeLayoutButton
  }));
}

var CssFixes = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  // TODO: !!!\n  ", ":last-child {\n    ", "\n  }\n\n  ", " {\n    ", ";\n  }\n"])), Section, mediaCSS({
  minHeight: (_minHeight = {}, _minHeight[ZERO_BREAKPOINT] = "", _minHeight.medium = 0, _minHeight)
}), FakeControlsWrap, function (_ref) {
  var a = _ref.withLayoutButtons;
  return a ? "" : "display: none;";
});
export default observer(RedocPage);
var pageQuery = "3649055225";